
<div class="app-licence-message">
    <div *ngIf="title" class="app-licence-title">{{ title }}</div>
    <div *ngIf="content" class="app-licence-content" [innerHTML]="formattedContent()"></div>
</div>
